import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
const navLinks = [
  { label: "About", href: "https://www.xpresspromotion.com/about" },
  { label: "Services", href: "https://www.xpresspromotion.com/" },
  { label: "Pricing", href: "https://www.xpresspromotion.com/pricing" },
  { label: "Resources", href: "https://www.xpresspromotion.com/resources" },
  { label: "Contact", href: "https://www.xpresspromotion.com/contact" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-hero-bg/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto section-padding flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <span className="text-lg md:text-xl font-bold text-hero-foreground tracking-tight">Xpress Inc</span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-hero-foreground/70 hover:text-hero-foreground transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="tel:8776047112"
          className="hidden md:flex items-center gap-2 bg-accent text-accent-foreground px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-accent/90 transition-colors duration-200 active:scale-[0.97]"
        >
          <Phone className="w-4 h-4" />
          (877) 604-7112
        </a>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-hero-foreground p-2"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-hero-bg border-t border-hero-foreground/10 px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="block text-base font-medium text-hero-foreground/80 hover:text-hero-foreground"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:8776047112"
            className="flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 rounded-lg text-sm font-semibold w-fit"
          >
            <Phone className="w-4 h-4" />
            (877) 604-7112
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
